var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFXtz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "120px",
    height: "120px",
    viewBox: "0 0 120 120",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\uA730XTZ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-37.4999631%",
    y1: "50.0001949%",
    x2: "112.499935%",
    y2: "50.0001949%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "18.4658%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F329F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-37.4999631%",
    y1: "50.0001949%",
    x2: "112.499935%",
    y2: "50.0001949%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F61FF",
    offset: "18.4658%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9F329F",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "60.0005631 13.507835 100.265658 36.7548123 100.265658 83.2487316 60.0005631 106.495567 19.7355392 83.2487316 19.7355392 36.7548123"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uA730XTZ",
    stroke: "none",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.385692,31.4871635 L59.9998872,2.97433393 L10.6143084,31.487167 L10.6143084,88.5129442 L59.9998872,117.025669 L109.385692,88.5129476 L109.385692,31.4871635 Z M59.9983389,8.92022235 L104.231645,34.4600072 L104.231645,85.5360352 L59.9983389,111.07582 L15.7650324,85.5360352 L15.7650324,34.4600072 L59.9983389,8.92022235 Z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.961531,27.1132505 L64.9998858,2.88674493 C61.9058739,1.10042088 58.0938966,1.10042456 54.9998881,2.88675458 L13.0384522,27.1132473 C9.94444553,28.8995763 8.03845943,32.2008442 8.03845943,35.7734972 L8.03845943,84.2266046 C8.03845943,87.7992634 9.94445167,91.1005357 13.0384663,92.8868626 L54.9999028,117.113265 C58.0939038,118.899584 61.9058668,118.899588 64.9998714,117.113275 L106.961516,92.8868662 C110.055541,91.100542 111.961541,87.7992641 111.961541,84.2265981 L111.961541,35.77351 C111.961541,32.2008502 110.055547,28.899577 106.961531,27.1132505 Z M64.9998917,8.83541218 L101.809832,30.0875833 C104.903849,31.8739097 106.809843,35.1751831 106.809843,38.7478433 L106.809843,81.2522541 C106.809843,84.8249201 104.903843,88.1261981 101.809818,89.9125223 L64.9998774,111.164613 C61.9058728,112.950925 58.0939098,112.950922 54.9999088,111.164603 L18.1901643,89.9125257 C15.0961496,88.1261988 13.1901574,84.8249264 13.1901574,81.2522677 L13.1901574,38.7478297 C13.1901574,35.1751768 15.0961434,31.873909 18.19015,30.0875799 L54.9998946,8.83542233 C58.0939028,7.04909235 61.9058798,7.04908848 64.9998917,8.83541218 Z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.0005986,108.942672 C87.0300566,108.942672 108.941641,87.0310884 108.941641,60.0016303 C108.941641,32.9723493 87.0300566,11.0607297 60.0005986,11.0607297 C32.9711759,11.0607297 11.0595564,32.9723493 11.0595564,60.0016303 C11.0595564,87.0310884 32.9711759,108.942672 60.0005986,108.942672 Z",
    id: "Path",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.2711165,73.4744693 C79.6830055,63.0674622 66.5911441,58.3370045 65.338212,57.8511737 C65.2870719,57.8256036 65.2870719,57.7744636 65.312642,57.7233235 L78.8136241,44.1712013 L78.8136241,42.7137089 C78.8059531,42.4759075 78.6167348,42.2866892 78.3789334,42.2790182 L53.4992826,42.2790182 L53.4992826,34.1221748 L53.4992826,34.1221748 L53.4992826,31.6674508 L44.3196376,33.5852039 L44.3196376,34.9659862 L44.8310384,34.9659862 C44.8310384,34.9659862 47.0812021,34.9659862 47.0812021,37.2161499 L47.0812021,42.2534481 L39.9727305,42.2534481 C39.8346523,42.2636762 39.7272581,42.3710703 39.7170301,42.5091486 L39.7170301,45.7054038 L47.1067722,45.7054038 L47.1067722,63.0674622 C47.1067722,68.5138812 50.6098679,72.2982473 56.746678,71.7868465 C58.009838,71.6615533 59.224415,71.2217486 60.2753437,70.5083444 C60.7381615,70.2117319 61.016875,69.7028881 61.016875,69.1531322 L61.016875,67.4399394 C59.0224117,68.7695816 57.3347889,68.6928714 57.3347889,68.6928714 C53.4481426,68.6928714 53.5248527,63.7578534 53.5248527,63.7578534 L53.5248527,45.7054038 L71.423882,45.7054038 L58.5365809,58.6949851 C58.5110108,60.4081779 58.4854408,61.7378201 58.4854408,61.7633901 C58.4803268,61.8017452 58.5084538,61.8349862 58.5468089,61.8401002 C58.5519229,61.8401002 58.5570369,61.8401002 58.5621509,61.8401002 C70.3755103,63.8345635 73.5717655,71.480006 73.5717655,73.7045997 C73.5717655,73.7045997 74.8502676,84.5207274 64.0341399,85.2622586 C64.0341399,85.2622586 56.9512383,85.5690991 55.6983062,82.7308244 C55.6522802,82.6387723 55.6931922,82.5262641 55.7852444,82.482795 C55.7903584,82.480238 55.7954724,82.477681 55.8005864,82.475124 C57.0049354,81.9713942 57.7848217,80.7900583 57.7694796,79.4834291 C57.7694796,77.3866857 56.4909775,75.6734929 53.8061231,75.6734929 C51.6326696,75.6734929 49.8427667,77.3866857 49.8427667,79.4834291 C49.8427667,79.4834291 48.819965,88.586364 64.0085699,88.3306636 C81.3450582,88.0238231 80.2711165,73.4744693 80.2711165,73.4744693 Z",
    id: "s",
    fill: "#505050",
    fillRule: "nonzero",
    mask: "url(#mask-4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFXtz);
export default __webpack_public_path__ + "static/media/fXTZ.884d5f8a6071c6c8de20d5696618dc23.svg";
export { ForwardRef as ReactComponent };